import { render, staticRenderFns } from "./AddEditDeclaredValueModal.vue?vue&type=template&id=26b5e4df&scoped=true"
import script from "./AddEditDeclaredValueModal.vue?vue&type=script&lang=ts"
export * from "./AddEditDeclaredValueModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26b5e4df",
  null
  
)

export default component.exports